// ============================================
// COMPONENT - Premium Gate (bloqueo genérico de funciones Premium)
// ============================================

import { FaCrown } from 'react-icons/fa6';
import { goToPremium } from '@/lib/premium';

interface PremiumGateProps {
  title: string;
  description: string;
  ctaLabel?: string;
  fullScreen?: boolean;
}

export const PremiumGate = ({
  title,
  description,
  ctaLabel = 'Ver Planes',
  fullScreen = true,
}: PremiumGateProps) => {
  const content = (
    <div className="w-full max-w-lg rounded-lg border border-purple-100 bg-white p-8 text-center shadow-sm">
      <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-gradient-to-r from-purple-100 to-pink-100">
        <FaCrown className="text-5xl text-purple-600" />
      </div>
      <h1 className="mt-5 text-2xl font-bold" style={{ color: '#11194F' }}>
        {title}
      </h1>
      <p className="mt-3 text-gray-600">{description}</p>
      <button
        type="button"
        onClick={() => goToPremium()}
        className="mt-6 inline-flex items-center justify-center rounded-lg bg-gradient-to-r from-purple-500 to-pink-500 px-6 py-3 text-sm font-bold text-white shadow-lg transition-all hover:scale-105 hover:shadow-xl"
      >
        {ctaLabel}
      </button>
    </div>
  );

  if (!fullScreen) {
    return <div className="py-16 text-center">{content}</div>;
  }

  return (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center bg-[#F5F7F4] px-4">
      {content}
    </div>
  );
};
